<full-calendar
  id="calendar"
  [options]="calendarOptions"
  (dateClick)="handleDateClick($event)"
  (eventClick)="handleDateClick($event)"
  (eventClickInfo)="handleDateClick($event)"
></full-calendar>
